import React from "react"
import Slider from "react-slick"
import styled from "styled-components"

import "../../../node_modules/slick-carousel/slick/slick.css"
import "../../../node_modules/slick-carousel/slick/slick-theme.css"

import { Container } from "reactstrap"
import Product from "../../components/product"
import { ArrowLeft, ArrowRight } from "../../components/sliderButton"

export default function ProductSlider(props) {
  const { className, title, settings, products } = props

  const count = products.length
  if (count < 2) return null

  const defautlSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: count < 5 ? count : 5,
    slidesToScroll: count < 5 ? count : 5,
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: count < 4 ? count : 4,
          slidesToScroll: count < 4 ? count : 4,
          nextArrow: <ArrowRight />,
          prevArrow: <ArrowLeft />,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: count < 3 ? count : 3,
          slidesToScroll: count < 3 ? count : 3,
          nextArrow: <ArrowRight />,
          prevArrow: <ArrowLeft />,
        },
      },
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    ...settings,
  }

  return (
    <section className={className}>
      <Container fluid>
        {title && <h3 className="mb-4 text-center">{title}</h3>}
        <SliderWrapper>
          <Slider {...defautlSettings}>
            {products.map((product) => (
              <div key={product.id} className="px-3">
                <Product key={product.id} product={product} />
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </Container>
    </section>
  )
}

const SliderWrapper = styled.div`
  @media (max-width: 575px) {
    margin: 0 -1rem;
  }
  @media (min-width: 576px) {
    .slick-slider {
      padding: 0 42px;
    }
  }
`
